<app-loading
  [loading] = loading
></app-loading>
<div class="row">
  <form>
    <div class="col-12">

    </div>
  </form>
</div>
<div class="row">
  <div class="col-md-12">
    <app-tabela titulo="Lista de FAQs"
                placeHolder="Buscar faqs"
                [colunas]="colunas"
                [linhas]="linhas"
                [botaoEditar]="false"
    ></app-tabela>
  </div>
</div>
